//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { TagsContext } from "../context/TagsContext";
import { ChevronLeft, ChevronRight } from "lucide-react";



//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function ContainerPageNavigation() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { tags, setTags } = useContext(TagsContext); // Estado que armazena a lista de Tags
    const { tagSearched, setTagSearched } = useContext(TagsContext);
    const { itemsPerPage, setItemsPerPage } = useContext(TagsContext); // Estado que armazena a quantidade de Itens por Página
    const { currentPage, setCurrentPage } = useContext(TagsContext); // Estado que armazena qual é a Página Atual que está sendo apresentada



    //---------- CRIAÇÃO DE VARIÁVEIS ---------//
    const tagsFiltred = tags.filter((tag) => // Variável que armazena as Tags Filtradas
        tag.nome.toLowerCase().includes(tagSearched.toLowerCase())
    );
    const totalPages = Math.ceil(tagsFiltred.length / itemsPerPage); // Variável que armazena o total de Páginas com Tags existentes 



    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            {/* DIV QUE CONTÊM A LEGENDA DAS PÁGINAS */}
            <div className="flex justify-between items-center text-sm text-ink-3">

                {/* LEGENDA DAS PÁGINAS */}
                <div>
                    {(currentPage * itemsPerPage) - itemsPerPage + 1}-{Math.min(currentPage * itemsPerPage, tagsFiltred.length)} de {tagsFiltred.length}
                </div>

                {/* DIV DE NAVEGAÇÃO DAS PÁGINAS */}
                <div className="flex items-center gap-3">

                    {/* SELECT DE TAGS POR PÁGINA */}
                    <select
                        value={itemsPerPage}
                        onChange={(e) => {
                            setItemsPerPage(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                        className="bg-surface-2 border border-white/[0.08] p-1 rounded"
                    >
                        {[10, 20, 50].map((n) => (
                            <option key={n} value={n}>{n}</option>
                        ))}
                    </select>

                    {/* BUTTON PÁGINA ANTERIOR */}
                    <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                        className="disabled:opacity-40"
                    >
                        <ChevronLeft className="w-4 h-4" />
                    </button>

                    {/* BUTTON PRÓXIMA POSTERIOR */}
                    <button
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                        className="disabled:opacity-40"
                    >
                        <ChevronRight className="w-4 h-4" />
                    </button>
                </div>
            </div>

        </>
    )
}